import React, { useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Input } from "antd";
// import CommonSelect from "./CommonSelect";
import CommonSelect from "../../../ui-compoenents/CommonSelect";
import PanchangSchema from "../schema";
// import { DatePicker } from "antd";
import AntdDatePickerField from "../../../ui-compoenents/AntdDatePickerField";
import AntdDateTimePickerField from "../../../ui-compoenents/AntDateTimePickerField";
import { useDispatch, useSelector } from "react-redux";
import {
  getPanchangDaysAsync,
  createPanchangAsync,
  getPanchangAsync,
} from "../../../data/redux/features/panchang/slice";
import { getSamvatAsync } from "../../../data/redux/features/samvat/slice";
import panchangInitialValues from "../initialValues";
import dayjs from "dayjs";

const DATETIME_FORMAT = process.env.REACT_APP_DATETIME_FORMAT;

const AddPanchangFormModal = ({ selectedUser }) => {
  const formRef = useRef(null);
  const dispach = useDispatch();
  const { loading: panchangLoading, daysData } = useSelector(
    (state) => state.panchang
  );
  const { loading: samvatLoading, samvatData } = useSelector(
    (state) => state.samvat
  );

  useEffect(() => {
    const modalElement = document.getElementById("add_panchnag_form_modal");
    const handleModalClose = () => {
      if (formRef.current) {
        formRef.current.resetForm();
      }
    };
    modalElement?.addEventListener("hidden.bs.modal", handleModalClose);
    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, []);

  useEffect(() => {
    dispach(getPanchangDaysAsync({}));
    dispach(getSamvatAsync({}));
  }, [dispach]);

  const samvatOptions = samvatData.map((item, index) => {
    return {
      value: item.value,
      label: item.value,
    };
  });

  const dayDataOptions = daysData.map((item, index) => {
    return {
      value: item.id,
      label: item.day[2] + ", " + item.day[0] + ", " + item.day[1],
    };
  });

  const finalInitailValues = useMemo(() => {
    if (selectedUser) {
      return {
        start_time: selectedUser?.start_time
          ? new Date(selectedUser.start_time)
          : null,
        end_time: selectedUser?.end_time
          ? new Date(selectedUser.end_time)
          : null,
        day: selectedUser?.day || null,
        samvat: selectedUser?.samvat || null,
      };
    }
    return panchangInitialValues;
  }, [selectedUser]);

  return (
    <div className="modal fade" id="add_panchnag_form_modal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <Formik
            innerRef={formRef}
            initialValues={finalInitailValues}
            validationSchema={PanchangSchema}
            onSubmit={async (values, actions) => {
              try {
                // Prepare payload
                const payload = {
                  start_time: dayjs(values.start_time).format(DATETIME_FORMAT),
                  end_time: dayjs(values.end_time).format(DATETIME_FORMAT),
                  day: values.day,
                  samvat: values.samvat,
                };

                const result = await dispach(
                  createPanchangAsync({ createPanchangValues: payload })
                ).unwrap();

                if (result) {
                  dispach(getPanchangAsync()).unwrap();
                }
                const modal = window.bootstrap.Modal.getInstance(
                  document.getElementById("add_panchnag_form_modal")
                );
                modal?.hide();
                actions.resetForm();
              } catch (error) {
                console.error("❌ Failed to create Panchang:", error);
              }
            }}
            enableReinitialize
          >
            {({ values, isSubmitting, actions, setFieldValue }) => (
              <Form>
                <div className="modal-header border-bottom pb-4">
                  <div>
                    <h6 className="modal-title fw-bold" id="sampleModalLabel">
                      {selectedUser ? "Edit" : "Add"} Panchang
                    </h6>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body pt-0">
                  <div className="row p-2 g-3">
                    {/* Start Date & Deadline */}
                    <div className="col-6 col-md-6">
                      <label className="form-label fw-semibold">
                        Start Time
                      </label>
                      <div className="d-flex gap-2">
                        <Field
                          name="start_time"
                          component={AntdDateTimePickerField}
                          placeholder="Select Start Date"
                        />
                      </div>
                      <div className="text-danger small">
                        <ErrorMessage name="start_time" />
                      </div>
                    </div>

                    <div className="col-6 col-md-6">
                      <label className="form-label fw-semibold">End Time</label>
                      <div className="d-flex gap-2">
                        <Field
                          name="end_time"
                          component={AntdDateTimePickerField}
                          startValue={values.start_time}
                          maxDay={process.env.DATE_TIME_PICKER_WINDOW}
                          placeholder="Select End Date"
                        />
                      </div>
                      <div className="text-danger small">
                        <ErrorMessage name="end_time" />
                      </div>
                    </div>

                    <div className="col-6 col-md-6 d-flex flex-column">
                      <label className="form-label fw-semibold">Tithi</label>
                      <Field
                        name="day"
                        component={CommonSelect}
                        placeholder="Select Tithi"
                        options={dayDataOptions}
                        className="custom-ant-select input-mb"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="day" />
                      </div>
                    </div>

                    <div className="col-6 col-md-6 d-flex flex-column">
                      <label className="form-label fw-semibold">Samvat</label>
                      <Field
                        name="samvat"
                        component={CommonSelect}
                        placeholder="Select Samvat"
                        options={samvatOptions}
                        className="custom-ant-select input-mb"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="samvat" />
                      </div>
                    </div>

                    {/* Project Description */}
                  </div>
                </div>

                {/* Modal Footer Buttons */}
                <div className="modal-footer border-top bg-white pt-3">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting || panchangLoading}
                  >
                    {selectedUser ? "Edit" : "Add"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddPanchangFormModal;
